import { State } from '../reducers/auth.reducers';
import { createSelector } from '@ngrx/store';
import { UserInfo } from '../../models/user-info';
import { AppState } from '../../../shared/store/app.reducer';

export const authStateSlice = (state: AppState) => state.auth;

export const getAuthenticated$ = createSelector(authStateSlice, (state: State): boolean => state.isAuthenticated);

export const getUserInfo$ = createSelector(
    authStateSlice,
    (state: State): UserInfo => (state && state.userInfo ? state.userInfo : null)
);

export const getUserFullName$ = createSelector(authStateSlice, (state: State): string =>
    state && state.userInfo ? `${state.userInfo.firstName} ${state.userInfo.lastName}` : null
);
